import { Button } from '@components/tailwind';
import { colorAttributeCompare } from "@features/pdp/attribute-sorting";
import DesignGridWrapper from '@features/pdp/components/DesignGridWrapper';
import { Breakpoints } from '@settings';
import { Views } from '@types';
import React, { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import ColorSwatches from '../../../../components/ColorSwatches';
import { MIYO_DISABLED_COLORS } from '../../settings';

const UpdateVariant = ({ bundleInfo, onChoiceChange, setView }) => {
  const isMobile = useMediaQuery({ maxWidth: Breakpoints.MD });

  const colorChoices = bundleInfo.bundle.memberChoiceItemIds[bundleInfo.customInfo.customizing].map(
    (itemId) => {
      const item = bundleInfo.itemsById[itemId];
      const colorId = item.attributes.color;
      const color = bundleInfo.attributesByKey.color[colorId];
      return Object.assign({}, color, {
        item,
        isInStock: item?.inStockNow,
        isAvailable: true,
        url: item.url,
      });
    }
  );

  const colors =
    colorChoices
      ?.filter(
        (color) =>
          color.item.canMiyo &&
          !MIYO_DISABLED_COLORS.includes(color.id) &&
          color.isInStock &&
          color.isAvailable
      )
      .toSorted(colorAttributeCompare) ?? [];

  const bundleItem = bundleInfo.selectedItems[bundleInfo.customInfo.customizing];
  const activeColor = colors.find((c) => c.id === bundleItem.attributes.color);

  const changeItemHandler = (swatchData) => () => {
    onChoiceChange && onChoiceChange(bundleInfo.customInfo.customizing, swatchData.item.id);
  };

  const defaultColorId = useMemo(() => {
    return activeColor?.item?.id;
  }, []);

  const onActionClick = (action: 'cancel' | 'update') => (e) => {
    e.preventDefault();

    if (action === 'cancel') {
      onChoiceChange && onChoiceChange(bundleInfo.customInfo.customizing, defaultColorId);
      setView(Views.DESIGN);
      return;
    }

    if (action === 'update') {
      setView(Views.DESIGN);
      return;
    }
  };

  const displayName = [bundleItem?.displayName, activeColor?.value].filter((v) => !!v).join(', ');

  return (
    <>
      <div className=''>
        <DesignGridWrapper maxHeight='calc(100dvh - 500px)'>
          <div className='tw-px-3'>
            <ColorSwatches
              colors={colors}
              activeColor={activeColor}
              itemHandler={changeItemHandler}
              wrapperClassName='tw-w-full tw-mt-1 tw-mb-6'
              indicateSale={false}
              swatchSize='sm'
            />
          </div>
        </DesignGridWrapper>

        <div className='tw-mt-5'>
          {activeColor && <p className='tw-mb-2 tw-text-center tw-text-xs tw-font-semibold'>{displayName}</p>}
          <div className='t-justify-between tw-flex tw-items-center tw-gap-3'>
            <div className='tw-w-3/4 sm:tw-w-4/5'>
              <Button
                variant='primary'
                size={isMobile ? 'sm' : 'base'}
                onClick={onActionClick('update')}
                fullWidth='all'>
                Update
              </Button>
            </div>
            <div className='tw-w-1/4 sm:tw-w-1/5'>
              <Button variant='link' onClick={onActionClick('cancel')} size={isMobile ? 'sm' : 'base'}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateVariant;
